import { AiFillClockCircle } from "react-icons/ai";

import { IconWithBorder } from "components";

import "./WorkTimeCard.scss";

export interface WorkTimeCardProps {
  workingTime: string;
  services: string | JSX.Element;
  note: string;
}

export const WorkTimeCard = ({
  workingTime,
  services,
  note
}: WorkTimeCardProps) => {
  const styledWorkingTime = workingTime.replace(/&nbsp;/g, "<br/>");

  return (
    <div className="work-time-card">
      <div className="work-time-card__header">
        <IconWithBorder size="large" className="work-time-card__header--icon">
          <AiFillClockCircle />
        </IconWithBorder>
        <p className="work-time-card__header--text">სამუშაო საათები</p>
      </div>
      {workingTime && (
        <div
          className="work-time-card__body"
          dangerouslySetInnerHTML={{ __html: styledWorkingTime }}
        />
      )}
      <div className="work-time-card__description">{note}</div>
    </div>
  );
};
